import { ReactJSXElement } from '@emotion/react/types/jsx-namespace'
import { Box, Card, CardProps, Divider, Stack } from '@mui/material'
import React, { FC } from 'react'

import { ModifyObjectType } from '../../utils'

type Props = ModifyObjectType<
  CardProps,
  {
    heading: ReactJSXElement
    actionsRight?: ReactJSXElement
    actionsLeft?: ReactJSXElement
  }
>

export const CardUI: FC<Props> = ({
  children,
  heading,
  actionsRight,
  actionsLeft,
  ...props
}) => {
  return (
    <Card elevation={4} {...props}>
      <Box px={2} pt={2} py={1} sx={{ bgcolor: 'primary.light' }}>
        <Stack
          direction="row"
          justifyContent={'space-between'}
          alignItems="flex-end"
          sx={{
            height: '34px'
          }}>
          <div>{actionsLeft}</div>
          {actionsRight}
        </Stack>
        {heading}
      </Box>
      <Divider />
      <Box px={2} pt={1} py={2}>
        {children}
      </Box>
    </Card>
  )
}
